import React, { useState } from 'react'
import { Button } from '@chakra-ui/react'
import api from 'services/api'

function getFilenameFromDisposition(header?: string) {
  if (!header) return 'contabil.xlsx'
  const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(header)
  const filename = decodeURIComponent(match?.[1] || match?.[2] || '')
  return filename || 'contabil.xlsx'
}

export function ExportAccountingButton() {
  const [loading, setLoading] = useState(false)

  const onClick = async () => {
    setLoading(true)
    try {
      const response = await api.get('/reports/accounting', { responseType: 'blob' })
      const blob: Blob = response.data
      const filename = getFilenameFromDisposition(
        (response.headers['content-disposition'] as string) || (response.headers['Content-Disposition'] as string)
      )

      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button size="sm" colorScheme="primary" onClick={onClick} isLoading={loading} textTransform="uppercase">
      Exportar contábil (XLSX)
    </Button>
  )
}
